import React from 'react';
import isNil from 'lodash/fp/isNil';

import { BarPopoverProps, formatValueOrRange } from './BarPopover.utils';

import { StyledBarPopover } from '../styled';
import { useTranslation } from 'react-i18next';

const BarPopover = ({ min, max, unit, value }: BarPopoverProps) => {
  const { t } = useTranslation();
  return (
    <StyledBarPopover>
      <span className="bar-popover">
        <span className="bar-popover-values">
          {!isNil(value) && `${t('Target')}: `}
          {formatValueOrRange(value, min, max)}
        </span>
        <span className="bar-popover-unit">{unit}</span>
      </span>
    </StyledBarPopover>
  );
};

export default BarPopover;
